import React, { FC } from "react";

type SelectOctaveRangeDropdownProps = {
  octaves: number[];
  selectedOctave: number;
  onSelect: (octave: number) => void;
};

const OctaveRangeDropdown: FC<SelectOctaveRangeDropdownProps> = ({
  octaves,
  selectedOctave,
  onSelect,
}) => {
  return (
    <div className="settings-row octave-range-row">
      <label className="control-label">Octaves:</label>
      <div className="settings-row-controls">
        <select
          className="btn btn-light btn-extra-small"
          value={selectedOctave ?? ""}
          onChange={(e) => onSelect(parseInt(e.target.value))}
          style={{ flexShrink: 0 }}
        >
          {octaves.map((num) => (
            <option key={num} value={num}>
              {num}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default OctaveRangeDropdown;
